import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=efdaaad2&scoped=true&"
import script from "./addTemplate.vue?vue&type=script&lang=js&"
export * from "./addTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdaaad2",
  null
  
)

export default component.exports